<template>
  <div class="aboutus-container">
    <common-header></common-header>
    <!-- <div class="about-banner"></div> -->
    <common-carousel :bannerlist="headerBannerList"></common-carousel>
    <div class="content-wrap">
      <div class="about-intro">
        <p>汽车之家（NYSE：ATHM）成立于2005年，为消费者提供优质的汽车消费和汽车生活服务，助力中国汽车产业蓬勃发展。</p>
        <p>我们致力于通过产品服务、数据技术、生态规则和资源为用户和客户赋能，建设“车内容、车交易、车金融、车生活” 4个圈，建立以数据和技术为核心的智能汽车生态圈，正式迈向智能化的3.0时代。</p>
      </div>
      <div class="about-service">
        <p class="title">探索，永无止境</p>
        <p class="desc">围绕看车、买车、用车多场景服务，为你提供更好的汽车消费和汽车生活服务</p>
        <ul class="service-list">
          <li class="service-item" v-for="(item, index) in services" :key="index">
            <p class="service-icon" :class="'service-icon' + index"></p>
            <span class="service-word">{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="about-footer">
      <common-carousel :bannerlist="footerBannerList"></common-carousel>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
/* eslint-disable */
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import carousel from '@/components/carousel'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-carousel': carousel,
    'common-footer': mainFooter
  },
  data () {
    return {
      services: ['车内容', '车交易', '车金融', '车生活'],
      headerBannerList: [
        {
          id: '0',
          name: 'index-banner1.jpg',
          path: 'introAutobi'
        },
        {
          id: '1',
          name: 'index-banner2.jpg',
          path: 'introAutoCloud'
        },
        {
          id: '2',
          name: 'index-banner3.png',
          path: 'introRecommand'
        },
        {
          id: '3',
          name: 'index-banner4.png',
          path: 'introZhibo'
        },
        {
          id: '4',
          name: 'index-banner_push.png',
          path: 'introPush'
        },
        {
          id: '5',
          name: 'index-banner_flash.png',
          path: 'introFlashback'
        },
        {
          id: '6',
          name: 'index-banner_player.png',
          path: 'introPlayer'
        }
      ],
      footerBannerList: [
        {
          id: '0',
          name: 'about-banner1.png'
        },
        {
          id: '1',
          name: 'about-banner2.png'
        },
        {
          id: '2',
          name: 'about-banner3.png'
        }
      ]
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1728,
    }
    window.trackPageView()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aboutus-container {
  background-color: #F7F9FA;
}
/* .about-banner {
  height: 420px;
  background-size: cover;
  background-image: url('./../assets/images/au-banner-header.png');
  background-repeat: no-repeat;
  margin-top: -1px;
} */
.content-wrap {
  width: 1200px;
  margin: 0 auto;
}
.about-intro {
  margin: 60px 0 80px;
}
.about-intro p {
  margin-top: 15px;
  font-family: 'PingFangSC-Regular';
  font-size: 15px;
  color: #20253F;
  line-height: 30px;
}
.about-service {
  margin-top: 80px;
  font-family: 'PingFangSC-Medium';
}
.about-service .title {
  font-family: 'PingFangSC-Medium';
  text-align: center;
  font-size: 30px;
  color: #20253F;
}
.about-service .desc {
  text-align: center;
  margin-top: 25px;
  font-size: 15px;
  color: #6F778F;
  font-family: 'PingFangSC-Regular';
}
.service-list {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 80px;
}
.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 268px;
  height: 268px;
  background-color: #fff;
  border: 1px solid rgba(151,151,151,0.15);
  box-shadow: 0 6px 23px 6px rgba(139,139,139,0.10);
  border-radius: 8px;
}
.service-icon {
  display: block;
  width: 184px;
  height: 208px;
  /* zoom: 0.5; */
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  margin-top: -54px;
}
.service-icon0 {
  background-image: url('./../assets/images/_icon-service0.png');
}
.service-icon1 {
  background-image: url('./../assets/images/_icon-service1.png');
}
.service-icon2 {
  background-image: url('./../assets/images/_icon-service2.png');
}
.service-icon3 {
  background-image: url('./../assets/images/_icon-service3.png');
}
.service-word {
  display: block;
  margin-top: -17px;
  font-family: 'PingFangSC-Medium';
  font-size: 24px;
  color: #20253F;
}
.about-footer {
  overflow: hidden;
  /* background-size: cover; */
  /* background-image: url('./../assets/images/au-banner-footer.png'); */
  /* background-repeat: no-repeat; */
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue